/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobStatisticsResponse {
    getFixupPrototypeFunction() { return BackgroundJobStatisticsResponse.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobStatisticsResponse>): BackgroundJobStatisticsResponse {
        let obj = Object.assign(new BackgroundJobStatisticsResponse(), model);
        BackgroundJobStatisticsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobStatisticsResponse>): BackgroundJobStatisticsResponse {
        if (!model) return null;
        return BackgroundJobStatisticsResponse.newInstance(<BackgroundJobStatisticsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobStatisticsResponse) {
        if (!obj) return;

        models.BackgroundJobStatisticsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobStatisticsResponse): boolean {
        Object.setPrototypeOf(obj, BackgroundJobStatisticsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.workers) {
            for (let key in this.workers) {
                let val = this.workers[key];
                if (val) {
                    models.BackgroundJobStatistics.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to service statistics model
     */
    workers: { [key: string]: models.BackgroundJobStatistics; };

}
